import { getLabel } from 'developer-docs-source/labels/index';
import themes from 'developer-docs-shared-components/config/themes';
import { generateUrlWithVersionFromBaseUrl } from 'developer-docs-shared-components/config/versionInfo';
import RelatedDocs from 'developer-docs-shared-components/components/RelatedDocs';
import { useLocation } from 'react-router-dom';
import { API_GUIDES_PREFIX, REFERENCE_PREFIX, isValidDocForLocale } from '../utils/urls';
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The 'Related Apis' section shown at the top of a Guide Page.
 */
const RelatedApiLink = ({
  overrideHref
}) => {
  const location = useLocation();
  const theme = useContext(ThemeContext);
  if (theme && theme.themeName === themes.PORTAL_AUTHED.themeName) {
    return null;
  }
  const path = location.pathname;
  const title = getLabel(path);
  if (!title) {
    return null;
  }
  const href = overrideHref !== null && overrideHref !== void 0 ? overrideHref : (() => {
    const currentGuideKey = location.pathname.replace(`/${API_GUIDES_PREFIX}/`, '');
    const apiReferenceKeyExists = isValidDocForLocale(currentGuideKey, 'reference/api', 'en-us');
    // do not show related api link if the reference page does not exist
    if (!apiReferenceKeyExists) {
      return null;
    }
    return `/${REFERENCE_PREFIX}${generateUrlWithVersionFromBaseUrl(`/${currentGuideKey}`)}`;
  })();
  if (!href) {
    return null;
  }
  return /*#__PURE__*/_jsx(RelatedDocs, {
    href: href,
    title: title,
    relatedDocType: "api"
  });
};
export default RelatedApiLink;